require("babel-polyfill");

import React from "react"

window.React = React;

// Make extension libraries global. Don't put anything else here!
window.$wr = require("lib/shared/WhooosReadingUtility");
window._ = require("underscore");
window.$ = require("jquery");

window.Mycroft = require("lib/integrations/Mycroft");
var CustomerIOClient = require("lib/integrations/CustomerIOClient");
// var NewRelicClient = require("lib/integrations/NewRelicClient");

window.dynamicRequire = require("lib/technical/DynamicRequire").require;
window.autobind = require("lib/technical/Autobind");

window.PropTypes = require("prop-types");
window.StrictPropTypes = require("airbnb-prop-types").forbidExtraProps;

var pagePropTypes = {
	history: PropTypes.object,
	location: PropTypes.object,
	match: PropTypes.object,
	staticContext: PropTypes.object,

	children: PropTypes.PropTypes.oneOfType([
		PropTypes.object,
		PropTypes.array
	]),
}

window.PageStrictPropTypes = function(propsTypes) {
	return window.StrictPropTypes(_.extend({}, pagePropTypes, propsTypes))
}

// ONLY FOR CONSOLE TESTING PURPOSES
window.NoUseCurrentUser = require("lib/account/CurrentUser");
window.NoUseCookies = require('js-cookie');

if ($wr.isDevelopment()) {
	var WhooosReadingClientApi = require("wr_apis/apis/wr_client_api/node_package/src/index.js")
	WhooosReadingClientApi.LegacyClient.setHost("localhost:3002", "http");
} else if ($wr.isStaging()) {
	var WhooosReadingClientApi = require("wr_apis/apis/wr_client_api/node_package/src/index.js")
	WhooosReadingClientApi.LegacyClient.setHost("api.savvashortondev.com", "https");
} else {
	var WhooosReadingClientApi = require("wr_apis/apis/wr_client_api/node_package/src/index.js")
	WhooosReadingClientApi.LegacyClient.setHost("api.whooosreading.org", "https");
}

if (!$wr.isAppdev()) {
	// Set up Albus stuff
	$wr.loadScript("/dependencies/albus.min.js", "Albus", () => {
		Albus.Dependencies = {
			Marked: require("marked")
		}

		// This is a little brittle...
		Albus.alternateErrorDisplay = function(errors) {
			window.wrNotifications.triggerDropDownNotification({
				title: "You're missing something.", text: errors.join(" "), 
				icon: "exclamation-sign", type: "error" });
		}
	})
}

// Load Fonts
var $head = $("head");
$head.append('<link href="https://fonts.googleapis.com/css?family=Didact+Gothic" rel="stylesheet" />');

if ($wr.isDevelopment()) {
	var faviconPath = "/fixed/favicon-dev.ico";
} else if ($wr.isAppdev()) {
	var faviconPath = "/fixed/favicon-wizards.ico";
} else {
	var faviconPath = "/fixed/favicon-1.ico";
}
$head.append('<link rel="icon" sizes="16x16 32x32 64x64" href="' + faviconPath + '">');

var fontLoaderScript = document.createElement('script');
$head.append(fontLoaderScript);

fontLoaderScript.onload = function() {
	try { Typekit.load({ async: true }); }catch(e){}
}
fontLoaderScript.src = "https://use.typekit.net/sat8ely.js";

// In production/staging, redirect to https
if ((window.location.protocol != "https:") && !($wr.isDevelopment() || $wr.isAppdev())) {
	var url = window.location.href.substring(window.location.protocol.length);
	window.location.href = "https:" + url;
}

if (!$wr.isDevelopment() && !$wr.isStaging()) {
	CustomerIOClient.init("204a51c74b5e3b6269a0");	
	// NewRelicClient.init();
}

if ($wr.isProduction()) {
	Mycroft.init("UA-47529006-3");
} else {
	Mycroft.init("UA-47529006-2", { onLocalhost: true });
}
Mycroft.initExceptionTracking();

$wr.initInactivityTimer();


// WEBPACK FOOTER //
// ./modules/lib/technical/AppInit.js